import {
  TAvailableChartTypeListParams,
  TAvailableChartTypeListResponse,
  TPatientListByChartResponse,
  TCourseInfoListByPatientParams,
  TCourseInfoListByChartResponse,
  TChartRoundListByPatientParams,
  TChartRoundListByPatientResponse,
  TChartTypeListByPatientParams,
  TChartTypeListByPatientResponse,
  TScoreReportParams,
  TScoreReportResponse,
} from 'types/apis/student';
import { createService } from './config/axios';
import qs from 'qs';

export const getAvaliableChartTypeList = async (
  courseInfoId: number,
  params: TAvailableChartTypeListParams
) => {
  const queryString = qs.stringify(params);
  const url = `/drop-down/student/chart-type-info/${courseInfoId}?${queryString}`;

  return await createService<TAvailableChartTypeListResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const getPatientListByChart = async () =>
  createService<TPatientListByChartResponse>({
    url: '/drop-down/student/patient-list-by-chart',
    options: {
      method: 'get',
    },
  });

export const getCourseInfoListByPatient = async (
  params: TCourseInfoListByPatientParams
) => {
  const queryString = qs.stringify(params);
  const url = `/drop-down/student/course-info-list-by-patient?${queryString}`;

  return await createService<TCourseInfoListByChartResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const getChartRoundListByPatient = async (
  params: TChartRoundListByPatientParams
) => {
  const queryString = qs.stringify(params);
  const url = `/drop-down/student/registered-chart-list-by-patient?${queryString}`;

  return await createService<TChartRoundListByPatientResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const getChartTypeListByPatient = async (
  params: TChartTypeListByPatientParams
) => {
  const queryString = qs.stringify(params);
  const url = `/drop-down/student/chart-type-with-submit-status?${queryString}`;

  return await createService<TChartTypeListByPatientResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};

export const getScoreReport = async (params: TScoreReportParams) => {
  const queryString = qs.stringify(params);
  const url = `/evaluate-chart/final-evaluation?${queryString}`;

  return await createService<TScoreReportResponse>({
    url,
    options: {
      method: 'get',
    },
  });
};
